$(document).ready(() => {
  const disabledSpecificDays = ["8-09-2017", "5-10-2017", "5-01-2017", "12-25-2017", "4-14-2017", "6-25-2017", "9-01-2017", "10-18-2017", "1-28-2017", "1-27-2017", "2-16-2018", "2-17-2018", "2-18-2018", "2-19-2018"];

  function getYMD(d) {
    const date = new Date(d)
    var year = date.getFullYear(), month = (date.getMonth() + 1), day = date.getDate()
    return `${month}-${day}-${year}`
  }

  function isDateDisabled(d) {
    const date = new Date(d)
    const day = date.getDay();
    if (day === 0) return true
    if (disabledSpecificDays.includes(getYMD(date))) return true
    if (new Date() > date) return true
    return false
  }

  function getAvailableDate(date) {
    let nextDate = new Date(date)
    while (isDateDisabled(nextDate)) {
      nextDate = new Date(nextDate.setDate(nextDate.getDate() + 1))
    }
    return nextDate
  }

  function disableSpecificDaysAndWeekends(d) {
    const date = new Date(d)
    var m = date.getMonth() + 1
    var d = date.getDate()
    var y = date.getFullYear();

    const day = date.getDay();
    if (disabledSpecificDays.includes(`${m}-${d}-${y}`)) {
      return [false]
    }
    if (new Date() > date) {
      return [false]
    }
    return [(day != 0)]
  }
  var d = new Date();
  var newDate = new Date(d.setDate(d.getDate() + 1));
  var year = newDate.getFullYear(), month = newDate.getMonth() + 1, day = newDate.getDate();
  var timeNow = d.getHours();

  if (timeNow >= 10) {
    $("#selectDate").datepicker({
      minDate: +1,
      maxDate: '+2M',
      beforeShowDay: jQuery.datepicker.noWeekends
    });

    $('#selectDate').datepicker('setDate', getAvailableDate(newDate))
  } else {

    const date = new Date()
    $("#selectDate").datepicker({
      minDate: 0,
      maxDate: '+2M',
      beforeShowDay: jQuery.datepicker.noWeekends
    });
    $('#selectDate').datepicker('setDate', getAvailableDate(date))
  }
  //^^To remove days of the week that aren't Saturday and Sunday, use this: // http://stackoverflow.com/questions/2968414/disable-specific-days-of-the-week-on-jquery-ui-datepicker^^^

  // check cart attributes


});

function checkField() {
  var checkName = false;
  var checkAdd = false;

  if(document.getElementById('recipients-name').value == ''){
    $('#ReciName').removeClass('error_none').addClass('error_show');
    checkName = false;
  }else{
    $('#ReciName').removeClass('error_show').addClass('error_none');
    checkName = true;
  }
  if(document.getElementById('recipients-delivery-address').value == ''){
    $('#deliveryAdd').removeClass('error_none').addClass('error_show');
    checkAdd = false;
  }else{
    $('#deliveryAdd').removeClass('error_show').addClass('error_none');
    checkAdd = true;
  }

  if(checkName && checkAdd){
    $('#checkoutValidation').trigger('click');
  }

}
